/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import * as Sebrae from '@sebrae/react-core';

import CharacteristicsEntrepreneur from '../characteristics-entrepreneur/characteristics-entrepreneur';
import DangerousCombinations from '../dangerous-combinations/dangerous-combinations';
import EntrepreneurialProfile from '../entrepreneurial-profile/entrepreneurial-profile';
import HeaderReport from '../header-report/header-report';
import JohariWindowBar from '../johari-window-bar/johari-window-bar';
import JohariWindowGraph from '../johari-window-graph/johari-window-graph';
import PyramidChart from '../pyramid-chart/pyramid-chart';
import { Container, Content, ContentWarp } from './report-detail-style';

import HeaderReportDetail from '../header-detail/header-detail';
import { useReportService } from '../../../../../hooks/services/report-service';
import { useInterviewService } from '../../../../../hooks/services/interview-service';
import { useMessage } from '../../../../../hooks/messages/useMessage';

function ReportDetail() {
  const { navigateTo, getRouteParam } = Sebrae.useSebraeRouter();
  const { handleError, handleAttention } = useMessage();


  const { getLastInterview } = useInterviewService();
  const { validetaReportOnline } = useReportService()


  const [isSearchSuccessful, setIsSearchSuccessful] = React.useState(false);


  const validate = React.useCallback(async () => {
    const cpf = getRouteParam('cpf');

    const cpfCleaned = cpf.trim().replaceAll('.', '').replaceAll('-', '');
    const isValidCpf = cpfCleaned.length === 11;

    if (!isValidCpf) {
      handleError('CPF inválido!');
      navigateTo(`/relatorio`);
      return;
    }
    try {
      const result = await getLastInterview(cpfCleaned);
      const resultValidReport = await validetaReportOnline(result.id)
      if (result !== undefined && resultValidReport) {
        setIsSearchSuccessful(true);
        return;
      }
      setIsSearchSuccessful(false);
      navigateTo(`/relatorio`);
    } catch (error) {
      handleAttention('Não existe uma entrevista válida para o CPF informado.');
      navigateTo(`/relatorio`);
      setIsSearchSuccessful(false);
    }
  }, [handleError, navigateTo, handleAttention, getRouteParam, validetaReportOnline, getLastInterview]);

  React.useEffect(() => {
    validate();
  }, [validate])


  if (!isSearchSuccessful) {
    return null;
  }

  return (
    <Container>
      <HeaderReport />
      <Content>
        <HeaderReportDetail />
        <ContentWarp>
          <EntrepreneurialProfile />
          <CharacteristicsEntrepreneur />
          <DangerousCombinations />
          <PyramidChart />
          <JohariWindowBar />
          <JohariWindowGraph />
        </ContentWarp>
      </Content>
    </Container>
  );
}
export default ReportDetail;
